document.addEventListener('DOMContentLoaded', function () {
  const giftWrapId = 50095483027789; // Gaveindpakningsproduktets variant ID
  const GIFT_PROP_NAME = 'Ønsker gaveindpakning';
  const GIFT_PROP_YES = 'Ja';

  let updateTimeout;

  function debounceUpdateGiftWraps() {
    clearTimeout(updateTimeout);
    updateTimeout = setTimeout(syncGiftWrapWithCart, 300);
  }

  async function syncGiftWrapWithCart() {
    try {
      const res = await fetch('/cart.js', {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      });

      const cart = await res.json();

      // Find gaveindpaknings-linjen (hvis den findes)
      const giftLine = cart.items.find((item) => item.id === giftWrapId);
      const currentGiftQty = giftLine ? giftLine.quantity : 0;

      // Tæl antal linjer (ikke quantity) hvor property = "Ja"
      const yesLines = cart.items.filter((item) => {
        // Spring selve gaveindpakningsproduktet over
        if (item.id === giftWrapId) return false;
        if (!item.properties) return false;

        const propValue = item.properties[GIFT_PROP_NAME];
        return propValue === GIFT_PROP_YES;
      });

      const desiredGiftQty = yesLines.length;

      // Hvis det allerede passer, gør vi ikke noget
      if (desiredGiftQty === currentGiftQty) {
        return;
      }

      // Hvis vi ikke længere ønsker gaveindpakning, men der ligger en i kurven -> sæt qty = 0
      if (desiredGiftQty === 0 && giftLine) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            id: giftLine.key, // line item key
            quantity: 0,
          }),
        });
        return;
      }

      // Hvis vi ønsker gaveindpakning (desiredGiftQty > 0)
      if (desiredGiftQty > 0) {
        if (giftLine) {
          // Opdater eksisterende gaveindpaknings-linje
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({
              id: giftLine.key,
              quantity: desiredGiftQty,
            }),
          });
        } else {
          // Tilføj gaveindpakningsproduktet som ny linje
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({
              id: giftWrapId,
              quantity: desiredGiftQty,
            }),
          });
        }
      }
    } catch (error) {
      console.error('Error syncing gift wrap with cart:', error);
    }
  }

  // Initialt kald, når siden er klar
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    debounceUpdateGiftWraps();
  } else {
    document.addEventListener('DOMContentLoaded', debounceUpdateGiftWraps);
  }

  // Reager når kunden ændrer select-feltet for gaveindpakning
  document.addEventListener('change', function (event) {
    const target = event.target;
    if (
      target.matches &&
      target.matches('select[name="properties[Ønsker gaveindpakning]"]')
    ) {
      debounceUpdateGiftWraps();
    }
  });

  // Fallback: overvåg cart DOM for ændringer (Dawn cart drawer / cart page)
  const possibleTargets = ['cart-items', 'cart-drawer', '.cart-items', '[data-cart-items]'];
  let observerTarget = null;

  for (const sel of possibleTargets) {
    const el = document.querySelector(sel);
    if (el) {
      observerTarget = el;
      break;
    }
  }

  if (!observerTarget) {
    observerTarget = document.body; // fallback hvis vi ikke finder noget bedre
  }

  const observer = new MutationObserver(function () {
    debounceUpdateGiftWraps();
  });

  observer.observe(observerTarget, { childList: true, subtree: true });
  document.addEventListener('cart:updated', function (event) {
  // Her kan du reagere når kurven er opdateret
  console.log("debounceUpdateGiftWraps()")
});
});
